import React from 'react';

import classes from './QuizOption.module.css';

import CheckIconWhite from '../../../assets/icons/check-white.svg';
import FileInputIcon from '../../../assets/icons/icon-select-file.svg';
import CloseIcon from '../../../assets/icons/icon-close-black.svg';
import TextImage from '../../../assets/textImage.png'
import { IsStringEmpty } from '../../../utilities/CommonMethods';

const QuizOption = (props) => {
    return (
        <>
            {
                props.forQuizForm === true
                    ? <div className={classes.QuizOptionContainer}>
                        <label className={[classes.InputLabel, classes.ForQuizForm].join(' ')} onClick={() => props.onOptionClicked(props.pos, props.questionType, props.questionId)}>
                            <div className={[classes.CheckIconDiv, props.questionType === "single" ? classes.Round : classes.Square, props.selected ? classes.Active : null].join(' ')}>
                                <img src={CheckIconWhite} alt="Option Checked Icon" className={[classes.CheckIcon, props.selected ? classes.ShowImage : null].join(' ')} />
                            </div>
                        </label>
                        {
                            props.optionType === "text"
                                ? // Text Input Field for Option
                                <div className={classes.OptionContainer}>
                                    <div className={classes.TextInputContainer}>
                                        <input
                                            type="text"
                                            placeholder={"Option " + (props.pos + 1)}
                                            value={props.value}
                                            className={classes.TextInput}
                                            onChange={(event) => props.onInputChanged(event, props.pos)} />
                                        <p className={classes.ErrorMessage}>{props.errorMessage}</p>
                                    </div>
                                    <label className={classes.ImageOptionContainer} title="Click to select a new image">
                                        <input
                                            type="file"
                                            onChange={(event) => props.onImageFileSelected(props.pos, event)}
                                            onClick={(event) => { event.target.value = null }}
                                            accept='.jpeg , .png , image/jpeg , image/png'
                                            className={classes.FileInput}
                                        />
                                        <img
                                            className={classes.InputIcon}
                                            src={FileInputIcon} alt="Select Image file for Option Icon"
                                        />

                                    </label>
                                    <img
                                        className={[classes.InputIcon, props.optionsListLength === 1 ? classes.Hide : ''].join(' ')}
                                        src={CloseIcon} alt="Remove Option"
                                        title="Remove Option"
                                        onClick={props.optionsListLength === 1 ? null : () => props.removeOptionClick(props.pos)}
                                    />

                                </div>

                                : // File Input Field for Option
                                <div className={classes.OptionContainerDiv}>
                                    <label className={classes.ImageOptionContainer2}>
                                        <input
                                            type="file"
                                            onChange={(event) => props.onImageFileSelected(props.pos, event)}
                                            onClick={(event) => { event.target.value = null }}
                                            accept='.jpeg , .png , image/jpeg , image/png'
                                            className={classes.FileInput}
                                        />
                                        <img
                                            className={classes.OptionImage}
                                            src={!IsStringEmpty(props.imgUrl) ? props.imgUrl : !IsStringEmpty(props.value) ? props.value : null}
                                            alt="Option Image"
                                        />
                                    </label>

                                    <div 
                                        className={classes.GoToTextMode}
                                        onClick={() => props.onOptionTextSelected(props.pos)}
                                    >
                                        <img className={classes.TextImage} src={TextImage}/>
                                    </div>

                                    <img
                                        className={[classes.InputIcon, props.optionsListLength === 1 ? classes.Hide : ''].join(' ')}
                                        src={CloseIcon} alt="Remove Option"
                                        title="Remove Option"
                                        onClick={props.optionsListLength === 1 ? null : () => props.removeOptionClick(props.pos)}
                                    />
                                </div>
                        }
                    </div>
                    : <label className={classes.InputLabel} onClick={() => props.onOptionClicked(props.pos, props.questionId)}>
                        <div className={[classes.CheckIconDiv, props.questionType === "single" ? classes.Round : classes.Square, props.selected ? classes.Active : null].join(' ')}>
                            <img src={CheckIconWhite} alt="Option Checked Icon" className={[classes.CheckIcon, props.selected ? classes.ShowImage : null].join(' ')} />
                        </div>

                        {props.optionType === "text"
                            ? props.optionData
                            : <img src={props.optionData} alt="Quiz Option pic" className={classes.OptionImage} />
                        }

                    </label>
            }
        </>
    );
}

export default QuizOption;